import { render, staticRenderFns } from "./positionLost.vue?vue&type=template&id=4ebe0ade&scoped=true&"
import script from "./positionLost.js?vue&type=script&lang=js&"
export * from "./positionLost.js?vue&type=script&lang=js&"
import style0 from "./positionLost.vue?vue&type=style&index=0&id=4ebe0ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe0ade",
  null
  
)

export default component.exports